var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { formatCurrency, getMoneyFormat } from '../helpers/currencies';
import { docReady } from '../helpers/doc-ready';
import { getProductsByTag } from '../helpers/admin-api';
import { getAvailableCurrencies } from '../helpers/currencies';
const pseudoVariants = () => __awaiter(void 0, void 0, void 0, function* () {
    const scriptTag = document.querySelector('#pseudo-variants-state');
    const state = scriptTag ? JSON.parse(scriptTag.innerHTML) : null;
    if (!state)
        return;
    const products = yield getProductsByTag(state.tag, state.isoCode, state.handle, state.sort_key, state.reverse);
    const pseudoVariantsBlock = document.querySelector('.product-info__pseudo-variants');
    if (!products) {
        if (pseudoVariantsBlock) {
            pseudoVariantsBlock.remove();
        }
        return;
    }
    const currencies = yield getAvailableCurrencies();
    if (currencies) {
        const selectedCountry = currencies.availableCountries.filter((country) => country.isoCode === state.isoCode)[0];
        const pseudoVariantsContainer = document.querySelector('[data-pseudo-variants-list]');
        const itemsContainer = pseudoVariantsContainer.querySelector('[data-pseudo-variants-items]');
        products.forEach(({ node }, i) => {
            const productItem = document.createElement('product-card');
            productItem.classList.add('product-card');
            productItem.innerHTML = `
      <a class="product-card__info">
        <svg viewBox="0 0 1000 1000">
          <use></use>
        </svg>
        <span class="product-card__type"></span>
        <span class="product-card__title"></span>
        <price-list class="price-list"><sale-price class="text-subdued"></sale-price></price-list>
      </a>`;
            const info = productItem.querySelector('.product-card__info');
            const type = productItem.querySelector('.product-card__type');
            const icon = productItem.querySelector('use');
            const title = productItem.querySelector('.product-card__title');
            const price = productItem.querySelector('.price-list sale-price');
            const moneyFormat = getMoneyFormat(selectedCountry);
            const money = formatCurrency(Number(node.contextualPricing.priceRange.maxVariantPrice.amount) * 100, moneyFormat);
            type.innerText = node.productType;
            info.setAttribute('href', `/products/${node.handle}`);
            info.setAttribute('aria-label', node.title);
            info.setAttribute('data-product-type', node.productType);
            icon.setAttribute('href', '#' + node.productType);
            title.innerText = node.title;
            price.innerText = `${money}`;
            itemsContainer.appendChild(productItem);
        });
        const carouselControl = document.querySelectorAll('[data-pseudo-variants-control]');
        const scrollAnim = (element, position) => {
            element.scrollTo({
                left: position,
                behavior: 'smooth',
            });
        };
        carouselControl.forEach((control) => {
            control.addEventListener('click', () => {
                const controlTarget = control.getAttribute('aria-controls');
                const targetCarousel = document.querySelector('#' + controlTarget);
                const scrollAmount = targetCarousel === null || targetCarousel === void 0 ? void 0 : targetCarousel.querySelector('product-card').offsetWidth;
                if (control.hasAttribute('data-control-prev')) {
                    scrollAnim(targetCarousel, targetCarousel.scrollLeft - scrollAmount);
                }
                else {
                    scrollAnim(targetCarousel, targetCarousel.scrollLeft + scrollAmount);
                }
            });
        });
    }
});
docReady(() => {
    pseudoVariants();
    const pseudoVariantsToggle = document.querySelector('[data-pseudo-variants-toggle]');
    const pseudoVariantsContainer = document.querySelector('[data-pseudo-variants-container]');
    if (pseudoVariantsToggle && pseudoVariantsContainer) {
        pseudoVariantsToggle.addEventListener('click', () => {
            pseudoVariantsToggle.classList.toggle('pseudo-variants__heading--open');
            pseudoVariantsContainer === null || pseudoVariantsContainer === void 0 ? void 0 : pseudoVariantsContainer.classList.toggle('pseudo-variants__accordion--hidden');
        });
    }
});
